import SvgIcon from "@mui/material/SvgIcon";
import React from "react";

export function InfoIcon(props) {
    return (
        <SvgIcon {...props}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.0697 9.90975C13.0241 10.1112 12.9883 10.2835 12.9623 10.4265L12.4542 13.5855H11.3012L10.7736 10.4265C10.7475 10.2965 10.7084 10.1275 10.6563 9.9195C10.6042 9.7115 10.5651 9.52625 10.5391 9.36375C10.513 9.20125 10.5 9.029 10.5 8.847V6H13.2163V8.847C13.2163 9.029 13.2033 9.20125 13.1772 9.36375C13.1512 9.52625 13.1153 9.70825 13.0697 9.90975Z"
                    fill="#2F80ED"/>
                <path
                    d="M10.9006 15.438C11.0849 15.2586 11.2955 15.1411 11.5324 15.0855C11.6389 15.0605 11.7508 15.048 11.8679 15.048C11.981 15.048 12.0895 15.0605 12.1932 15.0855C12.4239 15.1411 12.6314 15.2586 12.8157 15.438C13.0828 15.698 13.2163 16.0165 13.2163 16.3935C13.2163 16.7705 13.0828 17.0922 12.8157 17.3588C12.5486 17.6252 12.2327 17.7585 11.8679 17.7585C11.4901 17.7585 11.1677 17.6252 10.9006 17.3588C10.6335 17.0922 10.5 16.7705 10.5 16.3935C10.5 16.0165 10.6335 15.698 10.9006 15.438Z"
                    fill="#2F80ED"/>
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12Z"
                      fill="#2F80ED"/>
            </svg>
        </SvgIcon>
    )
}
